/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>盘点单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <!-- <el-date-picker
          v-model="date"
          type="date"
          placeholder="选择日期时间"
          @change="getData(date)"
          default-time="12:00:00"
        >
        </el-date-picker> -->
        <el-date-picker
          v-model="date"
          type="daterange"
          @change="getData(date)"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="addCount"
          >开始盘点单</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-upload2"
          @click="exportCount"
          >导出</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="goodsList"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <!-- </el-table-column> -->
      <el-table-column
        prop="profitAmount"
        label="盈亏总金额"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="totalNum" label="盘点总数" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="remake" label="备注" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="createBy" label="创建人" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="50%"
      @click="closeDialog('editForm')"
      close="closeDialog"
    >
      <el-form label-width="250px" :model="editForm" ref="editForm">
        <el-row>
          <el-col>
            <el-table :data="editForm" style="width: 100%">
              <el-table-column prop="name" label="商品名称" width="180">
              </el-table-column>
              <el-table-column prop="profitAmount" label="盈亏金额">
              </el-table-column>
              <el-table-column prop="oldStock" label="原库存">
              </el-table-column>
              <el-table-column prop="num" label="盘点数"></el-table-column>
              <el-table-column prop="costPrice" label="进货价">
              </el-table-column>
              <el-table-column prop="barcode" label="条码" width="180">
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('edit')">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { OrderList, OrderRefund, OrderDelete } from "../../api/payMG";
import Pagination from "../../components/Pagination";

import { blobValidate } from "@/utils/ruoyi";
import { saveAs } from "file-saver";

import {
  getGoodsList,
  getGoodsTypeList,
  getGoodsDetail,
  editGoodsInfo,
  getCountGoodsList, //获取盘点单列表
  getCountGoodsDetail, //获取盘点单详情
} from "@/api/api.js";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "预览",
      date: "",
      year: "",
      month: "",
      day: "",
      goodsStatus: "", //商品类型
      payway: [
        { key: "全部订单", value: 0 },
        { key: "已完成订单", value: 1 },
        { key: "已取消订单", value: 2 },
        { key: "已退款订单", value: 3 },
      ],
      goodsTypeList: [], //商品类型列表
      orderList: "", //订单列表
      goodName: "", //商品名称
      goodsList: [], //商品列表
      options: [
        { label: "是", value: 1 },
        { label: "否", value: 0 },
      ], //预下架选项
      editForm: {
        alarmInventory: "",
        barcode: "",
        costPrice: "",
        inventoryStock: "",
        name: " ",
        platformGoodsId: "",
        preTakedown: "",
        salePrice: "",
        stock: "",
        storeId: "",
        typeId: "",
        url: "",
        vipPrice: "",
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: "",
        orderNo: "",
        transId: "",
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem("token"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("token"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    let date = new Date();
    this.date = date;
    // this.getdata(this.formInline);
    this.getGoodsType(); //获取商品类型列表
    this.getData(date); //获取盘点单列表
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //获取商品类型列表
    getGoodsType() {
      getGoodsTypeList().then((res) => {
        //改变数组里元素的某个属性
        res.data.forEach((item) => {
          item.key = item.name;
          item.value = item.id;
        });
        //在数组开头添加一个元素
        res.data.unshift({ key: "所有", value: "" });
        this.goodsTypeList = res.data;
      });
    },
    //获取盘点单列表
    getData(date) {
      if (date != null) {
        localStorage.setItem("pandianDate", date);

        localStorage.setItem("pandianDate1", date[0]);
        localStorage.setItem("pandianDate2", date[1]);
      }

      console.log(date, "8888");
      // this.date=date;
      this.loading = true;
      //转化日期的格式
      // let data1 = new Date(date[1]);
      // this.startTime =
      //   data1.getFullYear() +
      //   "-" +
      //   ("0" + (data1.getMonth() + 1)).slice(-2) +
      //   "-" +
      //   ("0" + data1.getDate()).slice(-2);
      // console.log(data1,'9999');
      if (localStorage.getItem("pandianDate") == null) {
        this.date = date;
      } else {
        this.date[0] = localStorage.getItem("pandianDate1");
        this.date[1] = localStorage.getItem("pandianDate2");
      }

      getCountGoodsList({
        startTime: this.date[0],
        endTime: this.date[1],
        pageNo: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
        storeId: localStorage.getItem("storeId"),
      }).then((res) => {
        //改变数组里元素的某个属性
        // res.data.records.forEach((item)=>{
        //   item.payMethod = item.payMethod == 0 ? '微信' : '支付宝'
        //   item.orderStatus = item.orderStatus == 1 ? '已完成' : '生成中'
        //   item.newContent = item.content.replace(/\\n/g, '<br>')
        // })
        this.goodsList = res.data.list;
        this.loading = false;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.limit;
        this.pageparm.total = res.data.total;
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.pageparm.currentPage = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.formInline.limit = parm.pageSize;
      // this.getdata(this.formInline)
      this.getData();
    },
    // 添加订单
    addCount() {
      //跳转路由
      this.$router.push({
        path: "/goods/addCount",
      });
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = row;
      //获取盘点单详情
      getCountGoodsDetail(row.id).then((res) => {
        this.editForm = res.data.yzsInventoryGoodsDtos;
      });
      //   console.log(index, row, "333333");
    },
    // 编辑、增加页面保存方法
    submitForm() {
      //修改商品信息
      editGoodsInfo(this.editForm).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "商品信息修改成功!",
          });
          this.editFormVisible = false;
          this.getData();
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("支付配置信息删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      console.log(2222222);
      this.editFormVisible = false;
      // this.$refs[formName].resetFields();
      this.editForm = {};
    },

    //导出盘点单
    exportCount() {
      const date1 = localStorage.getItem("pandianDate1");
      const date2 = localStorage.getItem("pandianDate2");
      // let startDate = new Date(this.date);
      // this.date =
      //   startDate.getFullYear() +
      //   "-" +
      //   ("0" + (startDate.getMonth() + 1)).slice(-2) +
      //   "-" +
      //   ("0" + startDate.getDate()).slice(-2);
      this.$confirm("确定导出盘点单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .get(
              `https://ht.wteam.club/api/system/inventory/export?storeId=${localStorage.getItem(
                "storeId"
              )}&startTime=${date1}&endTime=${date2}`,
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                  token: localStorage.getItem("token"),
                  storeid: localStorage.getItem("storeId"),
                },
                responseType: "blob",
              }
            )
            .then(async (res) => {
              const isLogin = await blobValidate(res);
              if (res.status == 200) {
                if (isLogin) {
                  console.log(new Blob([res]));
                  const blob = new Blob([res.data]);
                  console.log("blob1111", blob);
                  saveAs(blob, `商品列表_${new Date().getTime()}.xlsx`);
                  this.$message({
                    type: "success",
                    message: "导出成功",
                  });
                } else {
                  const resText = await res.text();
                  const rspObj = JSON.parse(resText);
                  const errMsg =
                    errorCode[rspObj.code] ||
                    rspObj.msg ||
                    errorCode["default"];
                  this.$message.error(errMsg);
                }
                this.$modal.closeLoading();
              } else {
                this.$message.error("导出失败");
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消导出",
          });
        });
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/goods/countGoods.vue